"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearQueryParams = exports.parseQuery = void 0;
const startsWith_1 = __importDefault(require("lodash/startsWith"));
const qs = __importStar(require("@zipit/ls-core-sdk/dist/querystring"));
const parseQuery = () => {
    let { search } = window.location;
    if ((0, startsWith_1.default)(search, '?')) {
        search = search.substr(1);
    }
    return qs.parse(search);
};
exports.parseQuery = parseQuery;
const clearQueryParams = (paramNames) => {
    const query = (0, exports.parseQuery)();
    const numStartParams = Object.keys(query).length;
    for (const param of paramNames) {
        delete query[param];
    }
    const numNewParams = Object.keys(query).length;
    if (numStartParams === numNewParams) {
        return false;
    }
    let newQuery = '';
    if (numStartParams > 0) {
        newQuery = qs.stringify(query);
    }
    else {
        newQuery = '';
    }
    const { protocol, hostname, port, pathname, hash } = window.location;
    const host = window.location.origin
        ? window.location.origin
        : `${protocol}//${hostname}${port ? `:${port}` : ''}`;
    let newUrl = `${host}${pathname}${hash}${newQuery ? `?${newQuery}` : ''}`;
    window.history.replaceState({}, document.title, newUrl);
    return true;
};
exports.clearQueryParams = clearQueryParams;
//# sourceMappingURL=clearQueryParams.js.map